import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

export default class Toggle extends Component {
  static propTypes = {
    fullWidth: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
    value: PropTypes.string,
  }

  handleClickfactory = (value) => () => this.props.onChange(value)

  render() {
    const {
      fullWidth,
      options,
      value,
    } = this.props

    const groupClass = classnames([
      'toggle-buttons',
      'btn-group',
      fullWidth && 'btn-group--wide'
    ])

    return (
      <div className={groupClass}>
        {options.map((option) => (
          <button
            className={`btn btn--sm btn-group__btn ${value === option.value ? 'btn-group__btn--active' : ''}`}
            key={option.value}
            onClick={this.handleClickfactory(option.value)}
            type='button'
          >
            {option.label}
          </button>
        ))}
      </div>
    )
  }
}
